const txoLibInit = {

    showAll:false,
    enterPay:false,

}
export default txoLibInit;
